module.exports = __webpack_public_path__ + "videos/special-event_en.b5d5694.mp4";